import React from "react";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar.js";
import "./CommonContainerStyles.css";
import Tabs from "../../Components/Tabs/Tabs";
import CollegeAvatar from "../../Components/UserAvatar/CollegeAvatar";
import CollegeLogo from "../../Components/UserAvatar/CollegeLogo";
import StickyButton from "../../Components/Buttons/StickyButton.js";

function CollegePageContainer(props) {
  const { header, tabs, user, viewbookings } = props;

  const menuLogoBar =
    !user || !user.hasOwnProperty("personnel_email") ? (
      <SwitchMenuBar
        isViewAsCollege={true}
        viewbookings={viewbookings}
        isTeacherInfo={true}
      />
    ) : (
      <SwitchMenuBar
        isViewAsPersonnel={true}
        viewbookings={viewbookings}
        isTeacherInfo={true}
      />
    );

  return (
    <div className="page-container-outer">
      <div className="menu-logo-bar">{menuLogoBar}</div>
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"></div>
        <div className="page-container-header">
          <div className="page-container-header-inner">
            {/* <CollegeAvatar icon={user ? user.photo : null} /> */}
            <CollegeLogo />
            <h1>{header}</h1>
          </div>
        </div>
        <div className="page-container-inner">
          {tabs ? <Tabs tabs={tabs} /> : null}
          {props.children}
        </div>
      </div>
      {/* <StickyButton/> */}
    </div>
  );
}

export default CollegePageContainer;
